import constant from "../../constant";
import router from "../../router";
import Vue from "vue";
import { printData } from "../../utils/printUtils";

const api = constant.api + "attendances";

// initial state
const state = () => ({
  all: [],
  attendances: [],
  attendance: {},
  salaries: [],
  errors: {},
});

// getters
const getters = {
  getAll: (state) => {
    return state.all;
  },
  getAttendance: (state) => {
    return state.attendance;
  },
  getAttendances: (state) => {
    return state.attendances;
  },
  getErrors: (state) => {
    return state.errors;
  },
  getSalaries: (state) => {
    return state.salaries;
  },
};

// actions
const actions = {
  async getAll({ commit }) {
    try {
      const response = await Vue.prototype.$api.fetch(api);
      commit("setAttendances", response);
    } catch (error) {
      console.error("Error fetching attendances:", error);
      commit("setAttendances", []);
    }
  },
  async show({ commit }, reference) {
    try {
      const response = await Vue.prototype.$api.show(api + "/" + reference);
      commit("setAttendance", response.data);
    } catch (error) {
      console.error("Error fetching attendance:", error);
    }
  },
  async store({ commit, dispatch }, data) {
    try {
      const response = await Vue.prototype.$api.create(api, data, {
        confirm: false,
      });
      const message = response.data.message;
      const status = response.data.status;
      dispatch("notification/store", { status, message }, { root: true });
      return { status, data: response.data.data };
    } catch (error) {
      if (error.response && error.response.data) {
        commit("setErrors", error.response.data.errors || {});
      }
      dispatch(
        "notification/store",
        { status: "error", message: "Erreur lors de la création" },
        { root: true }
      );
      throw error;
    }
  },
  async update({ commit, dispatch }, data) {
    try {
      const response = await Vue.prototype.$api.update(
        api + "/" + data.reference,
        data,
        { confirm: false }
      );
      const message = response.data.message;
      const status = response.data.status;
      const attendance = response.data.data;
      dispatch("notification/store", { status, message }, { root: true });
      commit("setAttendance", attendance);
      return { status, data: attendance };
    } catch (error) {
      if (error.response && error.response.data) {
        commit("setErrors", error.response.data.errors || {});
      }
      dispatch(
        "notification/store",
        { status: "error", message: "Erreur lors de la mise à jour" },
        { root: true }
      );
      throw error;
    }
  },
  async destroy({ dispatch }, reference) {
    try {
      const response = await Vue.prototype.$api.delete(api + "/" + reference, {
        confirm: false,
      });
      const message = response.data.message;
      const status = response.data.status;
      dispatch("notification/store", { status, message }, { root: true });
      if (status == "success") {
        dispatch("getAll");
      }
    } catch (error) {
      console.error("Error deleting attendance:", error);
    }
  },
  async filter({ commit }, filters) {
    try {
      const response = await Vue.prototype.$api.create(
        api + "_filter",
        filters,
        { confirm: false }
      );
      commit("setAttendances", response.data);
    } catch (error) {
      console.error("Error filtering attendances:", error);
      commit("setAttendances", []);
    }
  },
  async printAllSalarySlips({ dispatch }, { month, year }) {
    await printData(
      {},
      api + "_print_all_salary_slips/" + month + "/" + year,
      "GET",
      null,
      null
    );
  },
  async printSalarySlip({ dispatch }, { employeeReference, month, year }) {
    await printData(
      {},
      api + "_print_salary_slip/" + employeeReference + "/" + month + "/" + year,
      "GET",
      null,
      null
    );
  },
  async getSalaries({ commit }, { month, year }) {
    try {
      const apiUrl = constant.api + "attendances_salaries";
      const response = await Vue.prototype.$api.fetch(apiUrl, { month, year });
      commit("setSalaries", response || []);
      return response || [];
    } catch (error) {
      console.error("Error fetching salaries:", error);
      commit("setSalaries", []);
      throw error;
    }
  },
};

// mutations
const mutations = {
  setAttendances(state, attendances) {
    state.all = attendances;
    state.attendances = attendances;
  },
  setAttendance(state, attendance) {
    state.attendance = attendance;
  },
  setErrors(state, errors) {
    state.errors = errors;
  },
  setSalaries(state, salaries) {
    state.salaries = salaries;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
